<template>
    <!-- <div class="w-full h-40px flex items-center px-[15px] "> -->
    <div class="w-full h-40px flex items-center px-[15px] cursor-pointer" @click="dialogVisible = true">创建设计</div>
    <!-- <el-popover placement="right" :width="420" trigger="click" :show-arrow="false">
        <template #reference>
            <div class="w-full h-40px flex items-center px-[15px] cursor-pointer">创建设计</div>
        </template>
<div class="content">
    <size />
</div>
</el-popover> -->
    <el-dialog v-model="dialogVisible" title="" width="430" top="100px" append-to-body>
        <size />
    </el-dialog>

    <!-- </div> -->
</template>
<script lang="ts" setup>
import { ElButton, ElPopover, ElIcon, ElDialog } from 'element-plus'
// @ts-ignore
import size from './size.vue'
import { ref } from 'vue'

const dialogVisible = ref(false)

</script>
